import { usePartnerships } from '@/components/AccountPage/Partnerships/hooks';
import { createContext, type ReactNode, useContext, useMemo } from 'react';
interface ReferralsContextType {
  isFreeUserOnPaidTrial: boolean;
  isLoading: boolean;
}
const ReferralsContext = createContext<ReferralsContextType | undefined>(undefined);
export interface ReferralsProviderProps {
  children: ReactNode;
}
export const ReferralsProvider = ({
  children
}: ReferralsProviderProps) => {
  const {
    partnershipsData,
    getPartnershipsDataQuery: {
      isLoading
    }
  } = usePartnerships();
  const value = useMemo(() => {
    const isFreeUserOnPaidTrial = !!partnershipsData?.subscriptionDetails?.is_free_trial;
    return {
      isLoading,
      isFreeUserOnPaidTrial
    };
  }, [partnershipsData?.subscriptionDetails?.is_free_trial, isLoading]);
  return <ReferralsContext.Provider value={value} data-sentry-element="ReferralsContext.Provider" data-sentry-component="ReferralsProvider" data-sentry-source-file="ReferralsProvider.tsx">
      {children}
    </ReferralsContext.Provider>;
};
export const useReferrals = () => {
  const context = useContext(ReferralsContext);
  if (!context) {
    throw new Error('useReferrals must be used within a ReferralsProvider');
  }
  return context;
};